import PriceChecker from './PriceChecker';

export default PriceChecker;
